import { FormattedMessage } from "react-intl";

interface IWholeDiscussionHeaderLineWithCounterProps {
  totalCountOf: "COMMENTS" | "REPLIES";
  totalCount: number;
}

export default function WholeDiscussionHeaderLineWithCounter({
  totalCount,
  totalCountOf,
}: IWholeDiscussionHeaderLineWithCounterProps) {
  return (
    <div className="flex items-center justify-between font-aeonik">
      {/* <strong className="text-sm font-medium tracking-wider text-slate-600 dark:text-gray-400">DISCUSSÃO</strong> */}

      {totalCount > 0 && (
        <div>
          {totalCountOf === "COMMENTS" && (
            <span className="text-sm font-medium text-slate-500 dark:text-gray-400">
              <FormattedMessage
                defaultMessage="{count, plural, =1 {# Comentário} other {# Comentários}}"
                id="P0E3Kj"
                values={{ count: totalCount }}
              />
            </span>
          )}

          {totalCountOf === "REPLIES" && (
            <span className="text-sm font-medium text-slate-500 dark:text-gray-400">
              <FormattedMessage
                defaultMessage="{count, plural, =1 {# Resposta} other {# Respostas}}"
                id="DaViyf"
                values={{ count: totalCount }}
              />
            </span>
          )}
        </div>
      )}
    </div>
  );
}
